







































import Vue from "vue";
import { mapGetters } from "vuex";
import moment from "moment";

//Component
import SecurityConfigurationCard from "@/views/App/SecurityAndConfiguration/SecurityManagement/SecurityConfigurationCard.vue";
import StocksConfigurationDetail from "@/views/App/SecurityAndConfiguration/StocksConfiguration/StocksConfigurationDetail.vue";

//Model
import { RollProfile } from "@/model/data/security/InstallationStocksConfiguration";
import { TemplateContentEnum } from "@/model/data/enums/TemplateContentEnum";
import { ConfigurationHistory } from "@/model/data/security/ConfigurationHistory";

export default Vue.extend({
    components: { SecurityConfigurationCard, StocksConfigurationDetail },
    props: {
        event: { type: Object as () => ConfigurationHistory, required: false },
        rollsProfile: { type: Object as () => RollProfile },
        showDialog: { type: Boolean, required: true },
        templateContent: { type: Number as () => TemplateContentEnum },
        loading: Boolean,
    },
    data() {
        return {
            moment,
        };
    },
    computed: {
        ...mapGetters(["longDateFormat"]),
        showEventConfigurationDialog: {
            get() {
                return this.showDialog;
            },
            set(newValue: boolean) {
                this.$emit("update:showDialog");
            },
        },
        eventName() {
            if (this.event.name) return this.$t("reference_configuration.templateImportEvent");
            else return this.$t("reference_configuration.configurationWriteEvent");
        },
    },
});
